import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import axios from "axios";

import RoomFeatureView from "../components/Views/RoomFeaturesView.jsx";
import EditForm from "../components/Views/EditForm.jsx";
import AddForm from "../components/Views/AddForm.jsx";
import Container from "./Container.jsx";
import ViewForm from "../components/Views/ViewForm.jsx";

import { createFormData } from "../lib/helperFuncs.jsx";

class RoomFeaturesContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("room_features");
    }

    componentDidMount = async () => {
        await this.getAuxData();
    };

    getBackLink = () => this.datasource.routes().home;

    updateCategory = () => {
        const formDataToSend = createFormData(this.state.currentItem);
        formDataToSend.append("_method", "PUT");

        const path =
            this.datasource?.dataPath +
            "/" +
            this.datasource?.modelName +
            "/" +
            this.state.currentItem?.id;

        this.setLoading(() => {
            axios
                .post(path, formDataToSend)
                .then((result) => {
                    alert(result.data.message);
                    this.props.history.push(this.datasource.routes().home);
                })
                .catch((result) => this.handleUpdateError(result.response));
        });
    };

    updateCategoryWithoutReload = () => {
        const formDataToSend = createFormData(this.state.currentItem);
        formDataToSend.append("_method", "PUT");

        const path =
            this.datasource?.dataPath +
            "/" +
            this.datasource?.modelName +
            "/" +
            this.state.currentItem?.id;

        return axios
            .post(path, formDataToSend)
            .then(() => alert("Успешно сохранено"))
            .catch((result) => this.handleUpdateError(result.response));
    };

    updateCategoryImage = (propName, imgFile) => {
        imgFile &&
            this.setState((prevState) => ({
                currentItem: {
                    ...prevState.currentItem,
                    [propName]: imgFile,
                },
            }));
    };

    addCategory = () => {
        const formDataToSend = createFormData(this.state.currentItem);
        const path =
            this.datasource?.dataPath + "/" + this.datasource?.modelName;

        this.setLoading(() => {
            axios
                .post(path, formDataToSend)
                .then((result) => {
                    alert(result.data.message);
                    this.props.history.push(this.datasource.routes().home);
                })
                .catch((result) => this.handleUpdateError(result.response));
        });
    };

    changeItemOrder = (item) => {
        const updatedItem = { ...item };
        Reflect.deleteProperty(updatedItem, "icon");

        this.datasource
            .updateOne(updatedItem)
            .then((result) => {
                alert(result.data.message);
            })
            .catch((e) => {
                this.handleUpdateError(e);
            });
    };

    initCurrentItem = () =>
        this.setState({
            currentItem: {
                ...this.datasource.getEmptyObject(),
                ...(this.props.auxData?.room_feature_categories?.length > 0 && {
                    room_feature_category_id:
                        this.props.auxData?.room_feature_categories[0].id,
                }),
            },
        });

    showAllItemsHandler = (itemIdx) => {
        if (itemIdx === undefined) return;
        const updatedAllItems = [...this.state.AllItems];
        const itemToUpdate = { ...updatedAllItems[itemIdx] };

        itemToUpdate.allFeaturesShown = itemToUpdate.allFeaturesShown
            ? false
            : true;

        updatedAllItems[itemIdx] = itemToUpdate;

        return this.setState({ AllItems: updatedAllItems });
    };

    render = () => {
        const notPermitted = this.checkAvailability();
        if (notPermitted) {
            return <Route render={() => <Redirect to="/" replace />} />;
        }

        const fields = this.datasource.getSchemaFields();
        const routes = this.datasource.routes();

        const formattedFields = { ...fields };
        Reflect.deleteProperty(formattedFields, "room_features");

        const formattedFieldsForViewAndEdit = { ...formattedFields };
        //Reflect.deleteProperty(
        //    formattedFieldsForViewAndEdit,
        //    "room_feature_category_id",
        //);

        return (
            <Switch>
                <Route path={routes.home} exact>
                    <RoomFeatureView
                        title="Список удобств"
                        columns={{
                            id: "Id",
                            name: "Наименование",
                            order: "Порядок",
                        }}
                        addRoute={routes.add}
                        initAction={this.getAllItems}
                        items={this.state.AllItems}
                        loading={this.state.loading}
                        viewAction={this.getViewLink}
                        editAction={this.getEditLink}
                        removeAction={this.removeItem}
                        updateParticularItem={this.changeItemOrder}
                        defaultSortfield="order"
                        showAllItemsHandler={this.showAllItemsHandler}
                    />
                </Route>
                <Route path={routes.add()} exact>
                    <AddForm
                        title={"Новое удобство"}
                        loading={this.state.loading}
                        fields={formattedFields}
                        initAction={this.initCurrentItem}
                        item={this.state.currentItem}
                        getBackLink={this.getBackLink}
                        submitAction={this.addCategory}
                        fieldUpdateHandler={this.setFieldValue}
                        errorFields={this.state.error}
                        setRelationsValue={this.setRelationsValue}
                        defaultValues={
                            this.props.auxData?.room_feature_categories
                        }
                        updateImage={this.updateCategoryImage}
                    />
                </Route>
                <Route path={routes.view(":id")} exact>
                    <ViewForm
                        title={"Просмотр удобства"}
                        loading={this.state.loading}
                        fields={formattedFieldsForViewAndEdit}
                        initAction={this.getItem}
                        item={this.state.currentItem}
                        getBackLink={this.getBackLink}
                    />
                </Route>
                <Route path={routes.edit(":id")} exact>
                    <EditForm
                        loading={this.state.loading}
                        item={this.state.currentItem}
                        fields={formattedFieldsForViewAndEdit}
                        errorFields={this.state.error}
                        initAction={this.getItem}
                        submitAction={this.updateCategory}
                        submitActionApply={this.updateCategoryWithoutReload}
                        getBackLink={this.getBackLink}
                        fieldUpdateHandler={this.setFieldValue}
                        defaultValues={
                            this.props.auxData?.room_feature_categories
                        }
                        updateImage={this.updateCategoryImage}
                        thisFeatures={true}
                    />
                </Route>
            </Switch>
        );
    };
}

RoomFeaturesContainer.propTypes = {
    auxEntity: PropTypes.array.isRequired,
    auxSource: PropTypes.func.isRequired,
    auxData: PropTypes.object.isRequired,
};

export default RoomFeaturesContainer;
